import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default async function apontamentoHeaderReport(
    visita,
    indicador,
    apontamento,
    params,
    optLabelConformidade,
    configIndicador,
    additionalColumn,
) {
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;

    if (_.isEmpty(params)) {
        return h.panel(
            [
                h.row(h.title("Amostra"), h.row(h.text(nomeAmostra))),
                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                ),
            ],
            { widths: ["*", "*"] },
        );
    }
    const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

    const talhao = h.text(getTalhaoNomeDisplay(apontamento));
    const areaTalhao = h.text(getTalhaoAreaDisplay(apontamento));

    let titleAr = [h.title("Talhão"), h.title("Área (ha)")];
    let valueAr = [talhao, areaTalhao];
    let tamAr = [];

    if (apontamento.variedade) {
        titleAr.push(h.title("Variedade"));
        valueAr.push(h.textField("variedade.variedade"));
        tamAr.push("*");
    }

    if (apontamento.corte) {
        titleAr.push(h.title("Corte"));
        valueAr.push(h.textField("corte"));
        tamAr.push(60);
    }

    if (!configIndicador || configIndicador.showTrator) {
        tamAr.push(60, 70);
        titleAr.push(h.title("Trator"));
        valueAr.push(h.textField("trator.numeroFrotaTrator"));
        tamAr.push("*");
    } else {
        tamAr.push("*", 70);
    }

    if (!configIndicador || configIndicador.showImplemento) {
        titleAr.push(h.title("Implemento"));
        valueAr.push(h.textField("implemento.numeroFrotaImplemento"));
        tamAr.push("*");
    }
    if (!configIndicador || configIndicador.showFrente) {
        titleAr.push(h.title("Frente"));
        valueAr.push(h.textField("frente"));
        tamAr.push(125);
    }

    if (configIndicador && configIndicador.addHeaderField) {
        configIndicador.addHeaderField.forEach((nc) => {
            titleAr.push(h.title(nc.label));

            let secConformidade = nc.secondConformidadeField ? nc.secondConformidadeField(apontamento) : false;
            valueAr.push(
                nc.secondConformidadeField
                    ? h.conformidadeField(secConformidade.conformidade, secConformidade.status, secConformidade.config)
                    : nc.valueGetter
                      ? h.text(nc.valueGetter(apontamento))
                      : h.textField(nc.field),
            );

            tamAr.push(nc.width);
        });
    }

    if (additionalColumn) {
        titleAr.push(h.title(additionalColumn.label));
        valueAr.push(h.textField(additionalColumn.field));
        tamAr.push(additionalColumn.width);
    }

    titleAr.push(h.title(optLabelConformidade || "Conformidade (%)", { alignment: "right" }));
    valueAr.push(h.conformidadeField("conformidade", status, { alignment: "right" }));
    tamAr.push(90);

    let valuesArFirstRow = [];
    let tamArFirstRow = [];

    valuesArFirstRow.push(h.title("Amostra"));
    valuesArFirstRow.push(h.text(nomeAmostra));
    tamArFirstRow.push(60);
    tamArFirstRow.push("*");

    valuesArFirstRow.push(h.title("Tipo"));
    valuesArFirstRow.push(h.textField("tipo"));
    tamArFirstRow.push(50);
    tamArFirstRow.push(70);

    if (!configIndicador || configIndicador.showMeta) {
        valuesArFirstRow.push(h.title(`Meta (${IndicadorClass.quantifierMeta || "%"})`));
        valuesArFirstRow.push(h.text(params.meta));
        tamArFirstRow.push(45);
        tamArFirstRow.push(40);
    }

    const content = [
        h.panel([h.row(...valuesArFirstRow)], { widths: tamArFirstRow }),

        h.panel([h.row(...titleAr), h.row(...valueAr)], { widths: tamAr }),
    ];

    return h.unbreakable(content);
}
